import apiClient from './client';
import type { ChatResponse, Message } from '../../types/chat.types';

export const chatApi = {
  async sendMessage(
    message: string,
    conversationHistory: Message[] = []
  ): Promise<ChatResponse> {
    try {
      // Extract last 6 messages (3 Q&A pairs) for context
      const recentHistory = conversationHistory
        .slice(-6)
        .map(msg => ({
          role: msg.role,
          content: msg.content
        }));

      // Backend expects 'question' and 'conversation_history'
      const payload = {
        question: message,
        conversation_history: recentHistory
      };

      const response = await apiClient.post<ChatResponse>('/api/chat', payload);
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  },
};
